import { Outlet } from '@tanstack/react-router'
import { UmbrellaNav } from '@/widgets/umbrella-nav/UmbrellaNav'

export function App() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <UmbrellaNav />
      <main className="container mx-auto px-4 py-8">
        <Outlet />
      </main>
    </div>
  )
}
